export type LoginEventSource = 'PRISME_BZ' | 'PRISME_EMPLOYE';

export interface LoginEventRow {
  id: number;
  user_email: string;
  client_id: number | null;
  source: LoginEventSource;
  logged_in_at: string; // ISO timestamp
}

export async function getBzLoginEvents(params?: {
  source?: LoginEventSource;
  limit?: number;
  days?: number;
}): Promise<LoginEventRow[]> {
  const qs = new URLSearchParams();
  if (params?.source) qs.set('source', params.source);
  if (params?.limit != null) qs.set('limit', String(params.limit));
  if (params?.days != null) qs.set('days', String(params.days));

  const res = await fetch(`/api/serq/admin/bz-login-events${qs.toString() ? `?${qs.toString()}` : ''}`, {
    credentials: 'include',
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || 'Erreur chargement logs de connexion');
  }
  const data = (await res.json()) as { success?: boolean; rows?: LoginEventRow[] };
  return Array.isArray(data.rows) ? data.rows : [];
}

